module.exports = __webpack_public_path__ + "components/app-buttons/static/google-play-9b5d1b47b73fd4a8127a8c33649c5a2b.svg";